import React from "react";
import { contactName } from "../../helpers/ContactName";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
    apiCall,
    getBranches, getCustomers
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import Select from "react-select";

class ReceivableAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            branches: [],
            customers: [],
            loading: false,
            selectedCustomer: [],
            formData: {
                customer_id: '',
                branch_id: '',
                description: '',
                amount: '',
                due_date: '',
                b_a: '',
                invoice_no: '',
            }
        }
    }

    async componentDidMount() {
        try {
            const allCustomers = await getCustomers();
            const customersOnly = allCustomers.filter(c => c.is_supplier === 0);
            this.setState({
                branches: await getBranches(),
                customers: customersOnly
            });
        } catch (e) {
            throw e;
        }
    }

    handleChange = (e) => {
        const { id, value } = e.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [id]: value
            }
        }));
    }
    handleCustomerChange = (selectedCustomer) => {
        const formattedSelectedOptions = {
            value: selectedCustomer.value,
            label: selectedCustomer.label,
        };
        this.setState((prevState) => ({

            formData: {
                ...prevState.formData,
                customer_id: formattedSelectedOptions.value
            },
            selectedCustomer: formattedSelectedOptions
        }));

    };
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { formData } = this.state;
        const receiveFormData = new FormData();
        Object.keys(formData).forEach(key => {
            receiveFormData.append(key, formData[key]);
        });
        try {
            const response = await apiCall('business/receivable/add', 'post', receiveFormData);
            this.setState({ loading: false });
            mainHelper.toastMessage(response.status, response.message);
        } catch (e) {
            this.setState({ loading: false });

        }
    }

    render() {
        const { loading, branches, customers, selectedCustomer } = this.state;
        const { userPermissions } = this.props;
        const userHasNewReceivablePermission = userPermissions.includes('new receivable');
        const customerFormattedOptions = customers && customers.map(option => ({
            value: option.id,
            label: contactName(option)
        }));
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Müşteri Yeni Cari Oluştur"
                            Breadcrumb={[
                                { name: "Finansal İşlemler", navigate: "" },
                                { name: "Yeni Cari Oluştur", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="body">
                                            <h6>Yeni Cari Ekle</h6>
                                            <div className="row clearfix">

                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <Select
                                                            id="customer" inputId="customer_id" name="customer_id"
                                                            placeholder="Müşteri Seçiniz..."
                                                            options={customerFormattedOptions}
                                                            value={selectedCustomer}
                                                            onChange={this.handleCustomerChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <select id='branch_id'
                                                            className="form-control"
                                                            onChange={this.handleChange}>
                                                            <option value="">Şube Seçiniz</option>
                                                            {branches && (branches.map(branch => (
                                                                <option key={branch.id}
                                                                    value={branch.id}>{branch.name}</option>
                                                            )))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <textarea
                                                            id="description"
                                                            className="form-control"
                                                            placeholder="Detay"
                                                            onChange={this.handleChange}>
                                                        </textarea>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <input
                                                            id="amount"
                                                            type="number"
                                                            step="0.01"
                                                            className="form-control"
                                                            placeholder="Tutar giriniz"
                                                            onChange={this.handleChange} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <select id='b_a'
                                                            className="form-control"
                                                            onChange={this.handleChange}>
                                                            <option value="">Cari Tipi Seçiniz</option>
                                                            <option value="alacak">Alacak</option>
                                                            <option value="borc">Borç</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <input
                                                            id="invoice_no"
                                                            type="text"
                                                            placeholder="Fatura No"
                                                            className="form-control"
                                                            onChange={this.handleChange} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="due_date"
                                                            className="font-weight-bold text-cyan">
                                                            Son Ödeme Tarihi
                                                        </label>
                                                        <input
                                                            id="due_date"
                                                            type="date"
                                                            className="form-control"
                                                            onChange={this.handleChange} />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div className="body">
                                            <div className="row clearfix justify-content-center">
                                                <div className="col-lg-6 col-md-12">
                                                    {loading ? (
                                                        <button className="btn btn-outline-primary btn-block"
                                                            disabled={true}
                                                            style={{ textAlign: "-webkit-center" }}>
                                                            Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                                                height={'24px'}
                                                                color="#268bd2"></ReactLoading>
                                                        </button>
                                                    ) :
                                                        <button disabled={!userHasNewReceivablePermission}
                                                            className="btn btn-outline-primary btn-block"
                                                            type="submit">
                                                            Kaydet
                                                        </button>}

                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(ReceivableAdd)));
